import React, { useState } from "react";
import { Button, Grid, Paper, TextField, Box, Typography } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { useNavigate } from "react-router-dom";
const ForgotPassword: React.FC = () => {
  const [email, setEmail] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const navigate = useNavigate();

  const validateEmail = (value: string) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
    return regex.test(value);
  };

  const isError = isSubmitted && !validateEmail(email);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value);
    setIsSuccess(false); // Reset success on change
  };

  const handleSubmit = () => {
    setIsSubmitted(true);
    if (validateEmail(email)) {
      console.log("Reset link sent to:", email);
      setIsSuccess(true);
    } else {
      setIsSuccess(false);
    }
  };
const handleChangeaaa = () => {
  console.log("Go To Login button clicked");
  navigate("/login"); 
};
  return (
    <Grid container component="main" sx={{ height: "100vh" }}>
      <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
        <Box
          sx={{
            my: 8,
            mx: 4,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <img src="/logo-pmi.png" alt="logo" />

          <Box sx={{ mt: 8, textAlign: "left", width: "440px" }}>
            <Typography
              variant="h5"
              fontWeight="bold"
              fontSize="30px"
              color="#1976D2"
              gutterBottom
            >
              Password changed!
            </Typography>
            <Typography
              variant="body1"
              mb={3}
              fontSize="16px"
              color="#282829"
              fontWeight="500"
            >
              You have successfully reset your account’s password. You can log into your account with the new password
            </Typography>

            <Button
              fullWidth
              variant="contained"
                onClick={handleChangeaaa}
              sx={{
                backgroundColor: "#C8172F",
                color: "#fff",
                textTransform: "none",
                borderRadius: 2,
                py: 1.5,
                boxShadow: 0,
                fontSize: "14px",
                lineHeight: 1.15,
                mt: 2,
              }}
            >
              Go To Login
            </Button>
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};

export default ForgotPassword;
